import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_INDICATIONREWARD] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.indicationreward = payload
  },
  [types.SET_INDICATIONREWARDS] (state, payload) {
    state.indicationrewards = payload.data
    state.pagination = payload.meta.pagination
  }
}
